import { Tkv2ReferenceBarProperty } from '../../controller/types.js';
import * as consts from './consts.js';

type ReferenceBarProps = {
  [consts.tkv2ReferenceViewIDAttr]: string;
  [consts.tkv2ReferenceMapPinLabelAttr]: string;
};

export function registerTkv2ReferenceProperty(prop: Tkv2ReferenceBarProperty): ReferenceBarProps {
  return {
    [consts.tkv2ReferenceViewIDAttr]: prop.id,
    [consts.tkv2ReferenceMapPinLabelAttr]: prop.mapPinLabel,
  };
}
